import { render, staticRenderFns } from "./schoolOverview.vue?vue&type=template&id=189f9d8e&scoped=true"
import script from "./schoolOverview.vue?vue&type=script&lang=js"
export * from "./schoolOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f9d8e",
  null
  
)

export default component.exports